import { getLocale, getProfileId } from 'lib/store';
import { apiClient } from 'services/api-client';
import {
  GetSymptomParams,
  SymptomCheckerReportResponse,
  SymptomQuestionPayload,
  SymptomQuestionResponse,
} from './type';

export const getSymptomReports = async (args?: {
  page_number: number;
  page_size: number;
}) => {
  return (await apiClient.get('symptom-checker-report-details', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      os: 'web',
      page_number: args?.page_number || 1,
      page_size: args?.page_size || 10,
    },
  })) as SymptomCheckerReportResponse;
};

export const getSymptomQuestion = async (symptomParams: GetSymptomParams) => {
  return (await apiClient.get('/symptom-checker', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      os: 'web',
      ...symptomParams,
    },
  })) as SymptomQuestionResponse;
};

export const getSymptomCheckerDetails = async (token_id: string) => {
  return await apiClient.get('/symptom-checker-report-details', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      token_id,
      os: 'web',
    },
  });
};

export async function postSymptomQuestion(data: SymptomQuestionPayload) {
  return (await apiClient.post('/symptom-checker', data, {
    params: {
      profile_id: getProfileId(),
      lang: getLocale(),
      type: data?.type || 'question',
      ...(data.email_flag && { email_flag: data.email_flag }),
    },
  })) as SymptomQuestionResponse;
}

export async function updateSymptomQuestion(data: SymptomQuestionPayload) {
  return (await apiClient.patch('/symptom-checker', data, {
    params: {
      profile_id: getProfileId(),
      lang: getLocale(),
    },
  })) as SymptomQuestionResponse;
}

export async function postSymptomFileUpload(data: FormData) {
  return (await apiClient.post('/symptom_checker_file_upload', data, {
    params: {
      profile_id: getProfileId(),
      lang: getLocale(),
    },
  })) as { image_url: string; token_id: string }[];
}

export async function deleteSymptomReports(token_id: string[]) {
  return await apiClient.delete('/symptom-checker-report-details', {
    data: { token_id },
    params: {
      profile_id: getProfileId(),
    },
  });
}
